import * as React from 'react';
export function useCarouselContextValues_unstable(state) {
    const { activeIndex, selectPageByElement, selectPageByDirection, selectPageByIndex, subscribeForValues, enableAutoplay, resetAutoplay, circular, containerRef } = state;
    const carousel = React.useMemo(()=>({
            activeIndex,
            selectPageByElement,
            selectPageByDirection,
            selectPageByIndex,
            subscribeForValues,
            enableAutoplay,
            resetAutoplay,
            circular,
            containerRef
        }), [
        activeIndex,
        selectPageByElement,
        selectPageByDirection,
        selectPageByIndex,
        subscribeForValues,
        enableAutoplay,
        resetAutoplay,
        circular,
        containerRef
    ]);
    return {
        carousel
    };
}
